// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"05dc0bec","453":"0bff6161","455":"f7f0d52d"}[chunkId] + ".chunk.js";
};